import { render, staticRenderFns } from "./OrganisationModal.vue?vue&type=template&id=6e21ab02"
import script from "./OrganisationModal.vue?vue&type=script&lang=js"
export * from "./OrganisationModal.vue?vue&type=script&lang=js"
import style0 from "./OrganisationModal.vue?vue&type=style&index=0&id=6e21ab02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports